// Hand-issued comped logins: accounts that get full access without a Stripe
// subscription and without a row in public.subscriptions being readable.
//
// Why this exists rather than only the DB grant (create_manual_account.sql):
// the DB path depends on the subscriptions RLS policy resolving for that user,
// and when it silently returns zero rows the person lands on /pricing with no
// way out. This list is the escape hatch that cannot fail that way.
//
// Security: the check is keyed on the *authenticated* email, so an address
// appearing in the shipped bundle grants nothing by itself. You still need the
// account password to become that user. Keep the list short, and remove an
// entry the moment the person no longer needs access.
//
// Adding someone: create the account (create_manual_account.sql or Studio ->
// Authentication -> Users -> Add user), then add the lowercase address here and
// redeploy the frontend.

export const COMPED_EMAILS = [
  'bd13f757361c@timetotalk.lt',
];

const COMPED_SET = new Set(COMPED_EMAILS.map((e) => e.toLowerCase().trim()));

export function isCompedEmail(email) {
  if (!email || typeof email !== 'string') return false;
  return COMPED_SET.has(email.toLowerCase().trim());
}
